import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const apollo = defineConnector({
  identifier: "apollo",
  name: "Apollo",
  tagLine: "Sales intelligence platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.apollo\\.io/.*",
  auth: (app) => headerAuth([{ name: "x-api-key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Find your Apollo API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [Apollo API key docs](https://docs.apollo.io/docs/create-api-key) and generate an API key from your Apollo account settings. Copy the key immediately, because you will paste it into the next step.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Enter the API credentials from your Apollo account settings.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          placeholder: "eh_3LUIFtj04rG4KF_FoFw",
          helperText: "The API key for your Apollo account",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.apollo.io/v1/auth/health",
  },
});
